import {Component, Input, Output, EventEmitter} from '@angular/core';
import {ContactService, ContactFilter, ContractsService} from '../../services';
import {ArrayExntension, AgentUtility} from '../../util';
import {StringUtility} from "../../util/string.utility";
import {ResponseApi} from "../../services/response/response";

@Component({
    moduleId: module.id,
    selector: 'contacts',
    templateUrl: 'contacts.component.html',
    styles: ['>>> ol.contacts {list-style-type: none;margin: 10px;}',
        ' ol.contacts li {padding:10px;} ol.contacts-inside {list-style-type: none;margin: 10px;}',
        '.letters{padding:5px;cursor:pointer;} .close{cursor:pointer;}.contact-search{width: 60%;}',
        '.popup-show{position: absolute;background-color: white;overflow-y: scroll;height: 300px;z-index:1;}'],
    providers: [ContactService, ContractsService]
})
export class ContactsComponent {

    public searchStr: string;
    public personSource: string[] = [];
    public letters: string[] = ['А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ж', 'З', 'И', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Э', 'Ю', 'Я'];
    public contacts: any = [];
    public contractsCount: number;
    public selectedContactType: any = {active: true, potential: false};
    public showLoadScreen: boolean = false;
    public searchResultShow: boolean = false;
    public agentUtility: AgentUtility = new AgentUtility();

    @Input() period: any;

    @Output() onSelected = new EventEmitter();

    constructor(private _contactsService: ContactService, private _contractsService: ContractsService) {
        this._contractsService.onStart = this._contactsService.onStart = () => this.showLoadScreen = true;
        this._contractsService.onEnd = this._contactsService.onEnd = () => this.showLoadScreen = false;
    }

    ngOnInit() {
        this.initUI();
    }

    public initUI() {
        let agentId = AgentUtility.getUser().Id;
        this._contactsService.getPeronsSource(agentId)
            .subscribe((data: ResponseApi) => {
                this.personSource = data.data;
            });

        this.contractsCount = 0;
        if (AgentUtility.GetCountCache() == null || AgentUtility.GetCountCache() == undefined) {
            this._contractsService.getActiveCount()
                .subscribe((data) => {
                    this.contractsCount = data.count;
                    AgentUtility.SetCountCache(data.count + "");
                });
        } else {
            this.contractsCount = AgentUtility.GetCountCache();
        }
    }

    splited(phone) {
        if (phone != null && phone != "")
            return phone.split(',');
    }

    public search(filter?: ContactFilter) {
        if (this.searchStr) {
            this.searchResultShow = true;
            let agentId = AgentUtility.getUser().Id;
            this._contactsService.getPersonsByFilter(filter ? filter : this.getFilter())
                .subscribe((data) => {
                    // Группировка списка контактов по имени клиента.
                    this.contacts = ArrayExntension.groupBy(data.data, 'PolicyHolder');
                });
        } else {
            this.onSelected.emit({contracts: []});
            this.clear();
        }
    }

    public clear() {
        this.searchResultShow = false;
        this.searchStr = '';
        this.contacts = [];
    }

    public getFilter(): ContactFilter {
        let agentId = AgentUtility.getUser().Id;
        return new ContactFilter(this.searchStr, this.searchStr, agentId);
    }

    public onClickLetter(event) {
        this.searchStr = event.currentTarget.innerText;
        this.search(this.getFilter());
    }

    public onClientNameClick(contact) {
        // из массива объектов берем только ид договоров.
        let contractIds = contact.value.reduce((result, item) => {
            if (!result.length)
                result = [Number.parseInt(item.Id)];
            else
                result.push(Number.parseInt(item.Id));

            return result
        }, {});

        this.onSelected.emit({contracts: contractIds});
        this.toggleSearchResultBlock();
    }

    public onContractClick(contract) {
        this.onSelected.emit({contracts: [Number.parseInt(contract.Id)]});
        this.toggleSearchResultBlock();
    }

    changeTab(tab) {
        if (tab == 'active')
            this.selectedContactType = {
                active: true,
                potential: false
            }
        else if (tab == 'potential')
            this.selectedContactType = {
                active: false,
                potential: true
            }
    }

    public toggleSearchResultBlock() {
        this.searchResultShow = !this.searchResultShow;
    }

    filterPhoneView(str) {
        return StringUtility.PhoneMask(str);
    }
}